define('modules/content_recommendations/content_recommendations_view',[
  'backbone',
  'jquery',
  '_',
  'modules/modal/modal_view',
  'modules/list/list_view',
  'modules/loading/loading_spinner_view',
  'modules/pagination/pagination_view',

  './collections/content_recommendations_collection',
  'modules/content_recommendations/modal/play_modal',
  'modules/content_recommendations/modal/pause_modal',
  'modules/campaigns/campaigns_ad_model',
  'modules/htmlad/player/htmlad_player_view',

  'text!./content_recommendations_template.html',
  'text!./collections/tactical_offers/tactical_offers_header_template.html',
  'text!./collections/tactical_offers/tactical_offers_list_item_template.html',
  'text!./collections/marketing/marketing_header_template.html',
  'text!./collections/marketing/marketing_list_item_template.html',
  'text!./collections/additional_marketing/additional_marketing_header_template.html',
  'text!./collections/additional_marketing/additional_marketing_list_item_template.html',
  'session',
], function (
  Backbone,
  $,
  _,
  ModalView,
  ListView,
  Loading,
  PaginationView,
  ContentRecommendationsCollection,
  PlayModal,
  PauseModal,
  AdModel,
  HtmlAdPlayer,
  content_recommendations_template,
  tactical_offers_header_template,
  tactical_offers_list_item_template,
  marketing_header_template,
  marketing_list_item_template,
  additional_marketing_header_template,
  additional_marketing_list_item_template,
  session
) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (opts) {
      _.extend(this, opts);

      this.pagination = false;
      this.collection = null;
      this.subViews = [];

      this.render();

      var loading = new Loading();
      this.subViews.push(loading);

      this.collection = ContentRecommendationsCollection;
      this.listenTo(this.collection, 'request', loading.start.bind(loading));
      this.listenTo(
        this.collection,
        'destroy',
        function (collection) {
          loading.done();
        },
        this
      );
      this.listenTo(
        this.collection,
        'sync',
        function (collection) {
          loading.done();

          $('.js-content-recommendations-loader').first().addClass('is-hidden');
          this.setTemplates();
          this.renderList();
          this.resetCheckBoxes();
          this.renderHeader();
          this.renderPagination();
        },
        this
      );

      Backbone.on('pagination:fetch', this.fetchContentRecommendations, this);
      Backbone.on('changeItemsStatusContentRecommendations', this.changeItemsStatusContentRecommendations, this);
      Backbone.on('switchType', this.switchType, this);
    },

    filterParams: [], // Get populated from filterModel change callback on the parent page.
    zoneList: [], // Get populated from filterModel change callback on the parent page.

    hasSidebar: false,
    subViews: [],

    activeCampaignType: 'tacticaloffer',

    template: _.template(content_recommendations_template),
    header_template: _.template(tactical_offers_header_template),
    item_template: _.template(tactical_offers_list_item_template),

    events: {
      'click .js-header-checkbox': 'selectAllBookings',
      'click .js-item-checkbox': 'onSelectBooking',
      'click .js-item-edit': 'onEditItem',
      'click .js-header-play-selected': 'playSelectedItems',
      'click .js-header-pause-selected': 'pauseSelectedItems',
      'click .js-item-play': 'playItem',
      'click .js-item-pause': 'pauseItem',
      'click .js-preview-item': 'previewMode',
    },

    switchType: function (campaignType) {
      this.activeCampaignType = campaignType;
    },

    fetchContentRecommendations: function () {
      if (
        !this.collection ||
        !this.collection.params ||
        Number.isNaN(this.collection.params.offset)
      ) {
        return;
      }

      var payload = {
        campaignType: this.activeCampaignType,
        campaignPeriod: this.filterParams.campaignPeriod || 'not_ended',
        zoneOptions: this.filterParams.zoneOptions || [],
        searchText: this.filterParams.searchText || '',
        metadata: this.collection.params || null,
        filterByTemplate: false
      };

      this.render();

      $('.js-content-recommendations-loader').first().removeClass('is-hidden');

      this.collection.fetch({
        type: 'POST',
        data: payload,
      });
    },

    playSelectedItems: function (e) {
      e.preventDefault();
      var selectedBookingIds = [];
      _.forEach($('.js-item-checkbox'), function (element) {
        if (element.checked) {
          if (element.dataset.bookingCopyId) {
            selectedBookingIds.push(parseInt(element.dataset.bookingCopyId));
          } else {
            selectedBookingIds.push(parseInt(element.dataset.bookingId));
          }
        }
      });
      this.openPlayModal(selectedBookingIds);
    },

    pauseSelectedItems: function (e) {
      e.preventDefault();
      var selectedBookingIds = [];
      _.forEach($('.js-item-checkbox'), function (element) {
        if (element.checked) {
          if (element.dataset.bookingCopyId) {
            selectedBookingIds.push(parseInt(element.dataset.bookingCopyId));
          } else {
            selectedBookingIds.push(parseInt(element.dataset.bookingId));
          }
        }
      });
      this.openPauseModal(selectedBookingIds);
    },

    playItem: function (e) {
      e.preventDefault();
      var bookingIds = [];

      // Bookingcopyid has a value if a local copy exist
      var bookingCopyId = parseInt(
        e.currentTarget.getAttribute('data-booking-copy-id')
      );
      if (Number.isNaN(bookingCopyId)) {
        bookingIds.push(
          parseInt(e.currentTarget.getAttribute('data-booking-id'))
        );
      } else {
        bookingIds.push(bookingCopyId);
      }
      this.openPlayModal(bookingIds);
    },

    pauseItem: function (e) {
      e.preventDefault();
      var bookingIds = [];

      // Bookingcopyid has a value if a local copy exist
      var bookingCopyId = parseInt(
        e.currentTarget.getAttribute('data-booking-copy-id')
      );
      if (Number.isNaN(bookingCopyId)) {
        bookingIds.push(
          parseInt(e.currentTarget.getAttribute('data-booking-id'))
        );
      } else {
        bookingIds.push(bookingCopyId);
      }
      this.openPauseModal(bookingIds);
    },

    openPlayModal: function (bookingIds) {
      var modal = new ModalView({
        title: _.t('content_recommendations.play_modal.title'),
        modalContent: new PlayModal({
          bookingIds: bookingIds,
          type: 'content_recommendation'
        }),
        bottom_toolbar: false,
      });
      modal.open();
    },

    openPauseModal: function (bookingIds) {
      var modal = new ModalView({
        title: _.t('content_recommendations.pause_modal.title'),
        modalContent: new PauseModal({
          bookingIds: bookingIds,
          type: 'content_recommendation',
        }),
        bottom_toolbar: false,
      });
      modal.open();
    },

    // Because the content recommendations list is made up of the original bookings we copy the info from the response (which belongs to the local copy booking)
    // into the fields in frontend
    changeItemsStatusContentRecommendations: function (bookingIds, shouldPlay) {
      var collection = this.collection;
      var bookingFinder = function (bookingId) {
        return collection.find(function (model) {
          return model.get('bookingId') === bookingId;
        });
      };
      $.ajax({
        type: 'PUT',
        url: session.get('apiUrl') + 'acrcampaignstatuses',
        data: { bookingIds: bookingIds, isPlaying: shouldPlay },
        dataType: 'json',
      })
        .success(
          function (data) {
            for (var i = 0; i < data.length; i++) {
              var booking = bookingFinder(data[i].bookingId);

              var bookingDiv;
              bookingDiv = document.querySelector(
                '[data-original-booking-id="' + data[i].bookingId + '"]'
              );
              if (bookingDiv === null) {
                bookingDiv = document.querySelector(
                  '[data-local-copy-booking-id="' + data[i].bookingId + '"]'
                );
              }

              if (data[i].bookingCopyId) {
                booking.set('bookingCopyId', data[i].bookingCopyId);
                bookingDiv.setAttribute(
                  'data-local-copy-booking-id',
                  data[i].bookingCopyId
                );

                var editButton = bookingDiv.querySelector('.js-item-edit');
                editButton.setAttribute(
                  'data-booking-copy-id',
                  data[i].bookingCopyId
                );

                var checkBox = bookingDiv.querySelector('.js-item-checkbox');
                checkBox.setAttribute(
                  'data-booking-copy-id',
                  data[i].bookingCopyId
                );

                var playButtons = bookingDiv.querySelectorAll('.js-item-play');
                for (var j = 0; j < playButtons.length; j++) {
                  playButtons[j].setAttribute(
                    'data-booking-copy-id',
                    data[i].bookingCopyId
                  );
                }
                var pauseButtons =
                  bookingDiv.querySelectorAll('.js-item-pause');
                for (var k = 0; k < pauseButtons.length; k++) {
                  pauseButtons[k].setAttribute(
                    'data-booking-copy-id',
                    data[i].bookingCopyId
                  );
                }
              }

              if (data[i].adId) {
                var previewItem = bookingDiv.querySelector('.js-preview-item');
                previewItem.setAttribute('data-ad-id', data[i].adId);
                if (data[i].thumbnail) {
                  var thumbnail = previewItem.querySelector('img');
                  thumbnail.src = _.media_url(data[i].thumbnail);
                }
              }

              if (data[i].broadcastStatus) {
                var broadcastStatus = bookingDiv.querySelectorAll(
                  '.content-recommendations-column-grid'
                );
                for (var l = 0; l < broadcastStatus.length; l++) {
                  if (
                    broadcastStatus[l].getAttribute('data-broadcastStatus') ===
                    data[i].broadcastStatus
                  ) {
                    broadcastStatus[l].classList.remove('hide');
                  } else {
                    broadcastStatus[l].classList.add('hide');
                  }
                }
              }

              if (data[i].zones) {
                var zones = bookingDiv.querySelector('.zones-field');
                var newZones = _.map(
                  data[i].zones,
                  function (zone, idx, array) {
                    return zone.zoneName;
                  }
                ).join(',');
                zones.innerHTML = newZones;
              }
            }
          }.bind(this)
        )
        .error(
          function (error) {
            this.fetchOffers();
          }.bind(this)
        );
    },

    onSelectBooking: function (e) {
      var targetModel = this.collection.find(function (model) {
        return model.get('bookingCode') === e.currentTarget.dataset.id;
      });
      targetModel.set('isChecked', !targetModel.get('isChecked'));

      var numberItemChecked = 0;
      _.forEach($('.js-item-checkbox'), function (inputElement) {
        if (inputElement.checked) {
          numberItemChecked++;
        }
      });

      // Update allSelect checkbox state
      var headerCheckbox = $('.js-header-checkbox');
      if (!headerCheckbox) {
        return;
      }
      headerCheckbox.prop('checked', numberItemChecked >= 1);

      var payload = {
        isChecked: numberItemChecked >= 1,
        numberOfItems: numberItemChecked,
      };
      this.renderHeader(payload);
    },

    selectAllBookings: function () {
      var headerCheckbox = $('.js-header-checkbox');
      if (!headerCheckbox) {
        return;
      }

      var isChecked = headerCheckbox.prop('checked');

      this.collection.each(function (model) {
        model.set('isChecked', isChecked);
      }, this);

      _.forEach($('.js-item-checkbox'), function (inputElement) {
        inputElement.checked = isChecked;
      });

      var payload = {
        isChecked: isChecked,
        numberOfItems: this.collection.length,
      };

      this.renderHeader(payload);
    },

    onEditItem: function (e) {
      e.preventDefault();
      var loading = new Loading();

      // Bookingcopyid has a value if a local copy exist.
      var bookingId = parseInt(e.currentTarget.getAttribute('data-booking-id'));
      var bookingCopyId = parseInt(
        e.currentTarget.getAttribute('data-booking-copy-id')
      );

      if (Number.isNaN(bookingCopyId)) {
        $.ajax({
          type: 'GET',
          url: session.get('apiUrl') + 'htmladlocation/' + bookingId + '/copyacr',
        })
          .success(
            function (data) {
              window.location.href = '/ads/' + data.id + '/edit';
            }.bind(this)
          )
          .error(
            function (error) {
              console.error(error);
              loading.done();
            }.bind(this)
          );
      } else {
        window.location.href = '/ads/' + bookingCopyId + '/edit';
      }
    },

    setTemplates: function () {
      if (this.activeCampaignType === 'tacticaloffer') {
        this.header_template = _.template(tactical_offers_header_template);
        this.item_template = _.template(tactical_offers_list_item_template);
      } else if (this.activeCampaignType === 'marketing') {
        this.header_template = _.template(marketing_header_template);
        this.item_template = _.template(marketing_list_item_template);
      } else {
        this.header_template = _.template(additional_marketing_header_template);
        this.item_template = _.template(additional_marketing_list_item_template);
      }
    },

    render: function () {
      this.$el.html(this.template());
      return this;
    },

    renderHeader: function (payload) {
      var templateInfo = {
        order_by: '',
        order: '',
        isChecked: false,
        numberOfItems: 0,
      };

      if (payload != null && payload.isChecked === true) {
        templateInfo.isChecked = payload.isChecked;
        templateInfo.numberOfItems = payload.numberOfItems;
      }

      if (this.collection && this.collection.params) {
        templateInfo.order_by = this.collection.params.order_by;
        templateInfo.order = this.collection.params.order;
      }

      this.$('.js-content-recommendations-header').html(
        this.header_template(templateInfo)
      );
      return this;
    },

    renderList: function () {
      var items = [];
      var contentRecommendationsList;

      this.collection.each(function (model) {
        if (!model.get('isChecked')) {
          model.set('isChecked', false);
        }
        items.push({ value: this.item_template(model.toJSON()) });
      }, this);

      contentRecommendationsList = new ListView({
        items: items,
        options: {
          search: false,
        },
      });

      this.$('.js-content-recommendations-list').html(
        contentRecommendationsList.$el
      );
      this.subViews.push(contentRecommendationsList);

      return this;
    },

    renderPagination: function () {
      if (this.pagination) {
        this.pagination.remove();
      }

      this.pagination = new PaginationView(this.collection, {
        useEventTriggerToInvokeRefresh: true,
      });
      this.subViews.push(this.pagination);

      this.$('.js-content-recommendations-pagination').html(
        this.pagination.$el
      );
      this.pagination.delegateEvents();
    },

    resetCheckBoxes: function () {
      var headerCheckbox = $('.js-header-checkbox');
      if (!headerCheckbox) {
        return this;
      }

      headerCheckbox.prop('checked', false);

      this.collection.each(function (model) {
        model.set('isChecked', false);
      }, this);

      _.forEach($('.js-item-checkbox'), function (inputElement) {
        inputElement.checked = false;
      });

      return this;
    },

    previewMode: function (e) {
      var self = this;
      var ad_id;
      var adModel;
      e.preventDefault();

      ad_id = e.currentTarget.dataset.adId;
      if (!ad_id) {
        return;
      }

      adModel = new AdModel({ id: ad_id });
      this.listenToOnce(
        adModel,
        'sync',
        function (model) {
          var previewModel;
          var htmlAdPlayer;

          previewModel = new Backbone.Model({
            name: model.get('title'),
            preview: model.get('preview_url'),
            metadata: {
              orientations: model.get('orientations'),
            },
          });
          htmlAdPlayer = new HtmlAdPlayer({
            model: previewModel,
            fitHeight: 600,
            close: function () {
              self
                .$('.js-content-recommendations-preview-iframe')
                .removeClass('ad-preview')
                .empty();
              this.remove();
            },
          });

          this.$('.js-content-recommendations-preview-iframe')
            .html(htmlAdPlayer.$el)
            .addClass('ad-preview');
        },
        this
      );
      adModel.fetch();
    },

    closePreview: function () {
      session.unset('current_preview');
      this.$el.removeClass('is-active');
      this.$('.js-preview-ad-container').removeClass('is-open');
    },

    remove: function () {
      Backbone.off('changeItemsStatusContentRecommendations');
      Backbone.off('switchType');
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    },
  });
  return View;
});

